import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Tweet from './Tweet';
import Art from './Art';
import akm from './cover.png';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
<nav className="Global-nav">
        <header className="App-header">
                  <img className="App-logo" alt="DR AK MEHTA IAS(R)" src={akm}/>
                  <br/>
                    <h1>Dr AK Mehta IAS(R)</h1>
                  </header>
        <ul className="Nav-list"> 
        <li><a href="#about">About  </a></li>
        <li><a href="#articles">Articles</a></li>
        <li><a href="#media">Media</a></li>
      </ul>
    </nav>

    <section id="about">
      <App />
    </section>

    <section id="articles">
      <Art />
    </section>

    <section id="media">
      <Tweet />
    </section>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
